import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyPrice", "annualPrice", "monthlyButton", "annualButton"]

  connect() {
    this.showAnnual()
  }

  showMonthly() {
    this.monthlyPriceTargets.forEach(el => el.classList.remove("hidden"))
    this.annualPriceTargets.forEach(el => el.classList.add("hidden"))
    this.monthlyButtonTarget.classList.add("bg-white", "shadow-sm", "text-neutral-900")
    this.monthlyButtonTarget.classList.remove("text-neutral-500")
    this.annualButtonTarget.classList.remove("bg-white", "shadow-sm", "text-neutral-900")
    this.annualButtonTarget.classList.add("text-neutral-500")
  }

  showAnnual() {
    this.annualPriceTargets.forEach(el => el.classList.remove("hidden"))
    this.monthlyPriceTargets.forEach(el => el.classList.add("hidden"))
    this.annualButtonTarget.classList.add("bg-white", "shadow-sm", "text-neutral-900")
    this.annualButtonTarget.classList.remove("text-neutral-500")
    this.monthlyButtonTarget.classList.remove("bg-white", "shadow-sm", "text-neutral-900")
    this.monthlyButtonTarget.classList.add("text-neutral-500")
  }
}
